import React from 'react'

export function InfinityIcon() {
    return <span><i className="fa fa-infinity" /></span>
}